import {get as _get} from 'lodash';
import initialState from '../initialstate';
import {GET_COUNTRIES} from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import normalizeCountries from './normalizeCountries';

export function countriesReducer(state = initialState.countries, action) {
	switch (action.type) {
		case GET_COUNTRIES: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return normalizeCountries(data);
			}
			return [];
		}
		default: {
			return state;
		}
	}
}
